document.addEventListener('alpine:init', () => {
  Alpine.data('filters', ({ filter }) => ({
    init() {
      this.filterIsOpen[filter] = true
    },

    closeMobileMenu() {
      this.mobileMenuIsOpen = false;
      document.body.classList.remove('overflow-hidden');
    },

    filterIsOpen: {},

    mobileMenuIsOpen: false,
    
    onChangeFilters(refName) {
      const ref = this.$refs[refName];
      const formData = new FormData(ref);

      this.updateParams(formData);
      this.updateView();
    },

    onClearFilter(refName, filter, filterValue) {
      this.$refs[`${refName}__${filter}`]
        .querySelectorAll(`input[value='${filterValue}']`)
        .forEach(x => x.checked = false);

      this.onChangeFilters(refName);
    },

    onClearFilters(refName) {
      this.$refs[refName]
        .querySelectorAll('input[type=checkbox]')
        .forEach(x => x.checked = false);

      this.onChangeFilters(refName);
    },

    openMobileMenu() {
      this.mobileMenuIsOpen = true;
      document.body.classList.add('overflow-hidden');
    },

    replaceElementById(doc, id) {
      const el = document.getElementById(id);
      const el_ = doc.getElementById(id);

      el.replaceWith(el_);
    },

    toggleFilterIsOpen(event, filter) {
      event.preventDefault();
      this.filterIsOpen[filter] = !this.filterIsOpen[filter];
    },

    updateParams(formData) {
      const path = location.pathname;
      const params = new URLSearchParams(window.location.search);

      [...params.entries()]
        .map(([x]) => x)
        .filter(x => x.includes('filter') || x === 'page')
        .forEach(x => params.delete(x));
      
      for (const [k, v] of formData.entries()) {
        params.append(k, v);
      }

      [...params].length ?
        window.history.pushState({}, '', `${path}?${params}`) :
        window.history.pushState({}, '', `${path}`);
    },

    updateView() {
      const url = window.location.href;
    
      fetch(url) 
        .then(x => x.text())
        .then(x => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(x, 'text/html');

          this.replaceElementById(doc, 'product-filters-mobile');
          this.replaceElementById(doc, 'product-filters-desktop');
          this.replaceElementById(doc, 'products-container');
          this.replaceElementById(doc, 'product-count');
        })
        .catch(x => console.error(x))
    }
  }));
});
